import { EditOutlined, LoadingOutlined } from '@ant-design/icons';
import { Card, Col, Row, Tooltip, theme } from 'antd';
import React from 'react';
import { CONFIG } from '../constants';

const { useToken } = theme;

const TextWithEditButton = ({
  type = 'primary',
  descripcion,
  tituloEditTooltip,
  onClick,
  icon,
  loading,
  ...props
}) => {
  const { token } = useToken();
  const styles = {
    icon: { fontSize: 16, color: token.colorTextDisabled, paddingLeft: 8 }
  };
  const iconCloned = icon
    ? React.cloneElement(icon, {
        style: styles.icon
      })
    : undefined;
  const getEditIcon = () => iconCloned || <EditOutlined style={styles.icon} />;
  return (
    <Tooltip title={tituloEditTooltip}>
      <Card
        hoverable
        style={{
          borderRadius: token.borderRadius,
          cursor: 'pointer',
          border:
            type === 'primary' ? `${CONFIG.COLOR_PRIMARY} 1px solid` : undefined
        }}
        bodyStyle={{
          padding: 10
        }}
        onClick={onClick}
        bordered
        {...props}
      >
        {descripcion || !loading ? (
          <>
            <Row justify="space-between" align="middle" wrap={false}>
              <Col>{descripcion}</Col>
              <Col>{getEditIcon()}</Col>
            </Row>
          </>
        ) : (
          <LoadingOutlined style={{ color: 'rgba(0,0,0,.45)' }} />
        )}
      </Card>
    </Tooltip>
  );
};

export default TextWithEditButton;
